import { get, post } from './../Config/config';


export const Users = {
    get: (data) => get('users', {params : data}),
    add: (data) => post('users/store', data),
    update: (data) => post('users/update', data),
    userRoles: (data) => get('users/list-roles', {params : data}),
    searchUserByEmail : (data) => get('users/search-by-mail', {params : data}),
    assignLead : (data) => get('leads/assign-user', {params : data}),
    myActivities : (data) => get('leads/my-activities', {params : data}),
}
